/**
 * Notification wrapper for better testability and dependency injection
 * Allows mocking of toast/message notifications in tests
 */
import { toast } from "react-toastify";

export interface NotificationService {
  success: (content: string) => void;
  error: (content: string) => void;
  warning: (content: string) => void;
  info: (content: string) => void;
}

/**
 * Default notification service using react-toastify
 */
export const defaultNotificationService: NotificationService = {
  success: (content: string) => {
    toast.success(content);
  },
  error: (content: string) => {
    toast.error(content);
  },
  warning: (content: string) => {
    toast.warning(content);
  },
  info: (content: string) => {
    toast.info(content);
  }
};

/**
 * Create a mock notification service for testing
 */
export const createMockNotificationService = (): NotificationService => ({
  success: jest.fn(),
  error: jest.fn(),
  warning: jest.fn(),
  info: jest.fn()
});
